<template>
  <div class="">
  
   <div class="indent mb-2">
     <div class="v-title">{{content.version}} {{content.title}}</div>
      <div class="indent" v-html="content.description"></div>
      <div v-for="item in content.subDocuments" :key="item.id">         
          
                <ByLawContentRefined :content="item" />
          
      </div>
   </div>
  </div>
</template>


<script>
import  "@/assets/sass/documentviewer.scss";
import ByLawContentRefined from '@/components/RefinedContent.vue';
export default {
  name: "ByLawContentRefined",
  components: {
    ByLawContentRefined
  },
  props: {
    content: Object
  },
  data() {
    return {
     
    };
  },  
  computed: {
    
  },
  mounted() {
   
  },
  methods: {
    
  },
  watch: {
  
  }
};
</script>
<style scoped>

</style>